module.exports = __webpack_public_path__ + "static/31-china-june2009-166e56cd87d337af15afb23421b4a9c9.jpg";